import React  from 'react';
import { useDispatch } from 'react-redux';
import { openDeletePrivModal, openEditPrivModal } from '../../Store/Slices/privSlice';
import { PaginationDetails } from '../../Utils/Utils';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, IconButton, Pagination , Box } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

const PrivilegeList = ({data}) => {
    const dispatch = useDispatch();
    const { page, count, handleChange, _DATA } = PaginationDetails(data);

    const handleEdit = (privId) => {
        dispatch(openEditPrivModal(privId));
    };

    const handleDelete = (privId) => {
        dispatch(openDeletePrivModal(privId));
    };

    const currentData = _DATA?.currentData() || data;

    const roles = sessionStorage.getItem("roles");

    return (
        <>
            <TableContainer sx={{ height: "43rem" }} >
                <Table  sx={{borderCollapse:'separate' , borderSpacing:'0px 4px' , height:'max-content'}} stickyHeader>
                    <TableHead  >
                        <TableRow >
                            <TableCell  width={50} >Privilege Id</TableCell>
                            <TableCell  width={50}>Privilege Name</TableCell>
                            <TableCell align="center" width={"30%"}>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody >
                        {currentData.map((priv) => (
                            <TableRow  sx={{ height: "30px" }} key={priv.privId}>
                                <TableCell  component='th' scope='row' sx={{ borderBottom: "none", fontWeight: 'bold', width: 100, height: 'auto !important' }}>#{priv.privId}</TableCell>
                                <TableCell sx={{ borderBottom: "none", width: 100, height: 'auto !important' }}>{priv.privName}</TableCell>
                                <TableCell align="center" sx={{ borderBottom: "none", width: '15%', height: 'auto !important' }}>
                                    {roles?.split(",").includes("PRIV_ES_EDIT_PRIVILEGE") ?  (<IconButton onClick={() => handleEdit(priv.privId)}>
                                        <EditIcon />
                                    </IconButton>) : null}
                                    {roles?.split(",").includes("PRIV_ES_DELETE_PRIVILEGE")  ? (<IconButton onClick={() => handleDelete(priv.privId)}>
                                        <DeleteIcon />
                                    </IconButton>) : null}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            
            </TableContainer>
            <Box my={2} display="flex" justifyContent="center">
                <Pagination
                    count={count}
                    page={page}
                    onChange={handleChange}
                    variant='outlined'
                    color="primary"
                    size='large'
                />
            </Box>
                
        
          
        </>
    );

};

export default PrivilegeList;